'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var classCallCheck = require('../../node_modules/@babel/runtime/helpers/classCallCheck.js');
var createClass = require('../../node_modules/@babel/runtime/helpers/createClass.js');
var possibleConstructorReturn = require('../../node_modules/@babel/runtime/helpers/possibleConstructorReturn.js');
var getPrototypeOf = require('../../node_modules/@babel/runtime/helpers/getPrototypeOf.js');
var inherits = require('../../node_modules/@babel/runtime/helpers/inherits.js');
var React = require('react');
require('prop-types');
var TimeSelectorLayout = require('./TimeSelectorLayout.js');
var CheckboxWithDay = require('./CheckboxWithDay.js');
var Grid = require('../../node_modules/@material-ui/core/esm/Grid/Grid.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var defaultOpenTime = '8:00';
var defaultCloseTime = '17:00';

var BusinessHoursSelector =
/*#__PURE__*/
function (_PureComponent) {
  inherits(BusinessHoursSelector, _PureComponent);

  function BusinessHoursSelector(props) {
    var _this;

    classCallCheck(this, BusinessHoursSelector);

    _this = possibleConstructorReturn(this, getPrototypeOf(BusinessHoursSelector).call(this, props));
    var singleDay = props.singleDay;
    _this.state = {
      isChecked: singleDay ? true : false,
      startTime: singleDay ? singleDay.openTime : defaultOpenTime,
      endTime: singleDay ? singleDay.closeTime : defaultCloseTime
    };
    return _this;
  }

  createClass(BusinessHoursSelector, [{
    key: "handleCheckboxChange",
    value: function handleCheckboxChange(event) {
      this.setState({
        isChecked: event.target.checked
      });

      if (event.target.checked) {
        this.props.onChange(this.props.dayOfWeek, this.state.startTime, this.state.endTime);
      } else {
        this.props.onChange(this.props.dayOfWeek);
      }
    }
  }, {
    key: "onTimePickerChange",
    value: function onTimePickerChange(timeStateLabel, newTime) {
      var _this2 = this;

      this.setState(defineProperty({}, timeStateLabel, newTime), function () {
        if (_this2.state.isChecked) {
          _this2.props.onChange(_this2.props.dayOfWeek, _this2.state.startTime, _this2.state.endTime);
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var dayOfWeek = this.props.dayOfWeek;
      var _this$state = this.state,
          isChecked = _this$state.isChecked,
          startTime = _this$state.startTime,
          endTime = _this$state.endTime;
      return React__default["default"].createElement(Grid["default"], {
        container: true,
        alignItems: "center"
      }, React__default["default"].createElement(Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, React__default["default"].createElement(CheckboxWithDay, {
        defaultChecked: isChecked,
        handleCheckboxChange: function handleCheckboxChange(event) {
          return _this3.handleCheckboxChange(event);
        },
        dayOfWeek: dayOfWeek
      })), React__default["default"].createElement(Grid["default"], {
        item: true
      }, React__default["default"].createElement(TimeSelectorLayout, {
        defaultChecked: isChecked,
        startTime: startTime,
        endTime: endTime,
        onChange: function onChange(timeStateLabel, newTime) {
          return _this3.onTimePickerChange(timeStateLabel, newTime);
        }
      })));
    }
  }]);

  return BusinessHoursSelector;
}(React.PureComponent);
BusinessHoursSelector.defaultProps = {
  onChange: function onChange() {}
};

module.exports = BusinessHoursSelector;
